import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { IGlob } from '../ts/Glob';
import { ProgressBar } from '../../../_common/platform/tsx/ProgressBar';
import ResourceList from '../../../pdc-widget-resource-manager/src/ts/react/ResourceList';
import DirsTreeFlat, { calculateSelectAllState, DirsTreeModes, IContentItems } from './DirsTreeFlat';
import { IRMInstanceState } from '../../../pdc-widget-resource-manager/src/ts/flux/Store';
import { IMarkedItems } from '../ts/Interfaces';

import {
    store as RMStore,
    dispatcher as RMDisp,
    actions as RMActions
} from '../../../pdc-widget-resource-manager/src/ts/flux/glob';

export default class DirsResourcesFlat extends React.Component<
    {
        instanceId: string;
        name: string;
        selectedDirId?: number;
        markMode?: boolean;
        markedDirs?: IMarkedItems;
        markedItems?: IMarkedItems;
        useSearching?: boolean;
        glob: IGlob;

        onDirSelect?(id: number, name: string): void;
        onItemsMark?(marked: IMarkedItems): void;
        onDirsMark?(marked: IMarkedItems): void;
        onMark?(markedDirs: IMarkedItems, markedItems: IMarkedItems): void;
    },
    {
        storeState: IRMInstanceState;
        selectedDirId: number;
        dirTreeInstanceId: string;
        markedDirs: IMarkedItems;
        markedItems: IMarkedItems;
    }
> {
    constructor(props) {
        super(props);

        const rmState = RMStore.getInstanceState(this.props.instanceId);

        this.state = {
            storeState: rmState,
            selectedDirId: this.props.selectedDirId || -1,
            dirTreeInstanceId: 'resources-export',
            markedDirs: this.props.markedDirs,
            markedItems: this.props.markedItems
        };
    }

    componentDidMount() {
        if (_.isEmpty(RMStore.glob)) {
            RMStore.glob = this.props.glob;
        }

        RMStore.addChangeListener(this.handleOnStoreChange);

        if (this.props.selectedDirId === -1) {
            RMActions.getResourceTreeRoot(this.props.instanceId);
        }
    }

    componentWillUnmount() {
        RMStore.removeChangeListener(this.handleOnStoreChange);
    }

    handleOnStoreChange = () => {
        const rmState = RMStore.getInstanceState(this.props.instanceId);

        if (this.state.storeState.resourceTreeRootDirId !== -1 && this.state.selectedDirId === -1) {
            this.setState({
                storeState: rmState,
                selectedDirId: this.state.storeState.resourceTreeRootDirId,
                dirTreeInstanceId: this.props.instanceId //'resource-tree-' + this.state.RMState.resourceTreeRootDirId
            });
            this.props.onDirSelect(this.state.storeState.resourceTreeRootDirId, '');
        } else {
            this.setState({ storeState: rmState });
        }
    };

    handleOnDirSelect = (id: number, name: string) => {
        RMActions.getDirContent(this.props.instanceId, id);
        this.setState({
            selectedDirId: id
        });
        RMActions.setResourceSelected(this.props.instanceId, {});

        if (typeof this.props.onDirSelect === 'function') {
            this.props.onDirSelect(id, name);
        }
    };

    handleOnResourceSelected = (selectedResources: IMarkedItems) => {
        RMActions.setResourceSelected(this.props.instanceId, selectedResources);
        this.props.onItemsMark(selectedResources);
    };

    getView() {
        if (this.state.storeState.dirContent == null || this.state.storeState.dirContent.length === 0) {
            return <em>{'No Resources here'}</em>;
        }

        return (
            <div className="pdc-widget-resource-manager">
                <ResourceList
                    instanceId={this.props.instanceId}
                    view={2} // List with small icons.
                    selectedResources={this.state.storeState.selectedResources}
                    dirContent={this.state.storeState.dirContent}
                    glob={this.props.glob}
                    onSelect={this.handleOnResourceSelected}
                />
            </div>
        );
    }

    handleOnDirsMark = (obj) => {
        if (typeof this.props.onDirsMark === 'function') {
            this.props.onDirsMark(obj);
        }
    };

    getContentKeys(): IContentItems {
        const rootId = this.state.storeState.resourceTreeRootDirId;
        const dirsData = this.props.glob.DirsStore._state.data[rootId];
        // VR: this is WRONG! even in 1.6 ver!!!const dirsData = this.props.glob.DirsStore._state.data[this.state.selectedDirId];
        const dirsHash = dirsData && dirsData.data && dirsData.data.dirsHash;
        // const dirs = _.map(
        //     _.pluck(
        //         dirsHash && dirsHash[this.state.selectedDirId] && dirsHash[this.state.selectedDirId].subdirlist,
        //         'dirid'
        //     ),
        //     (id) => {
        //         return id.toString();
        //     }
        // );
        const dirs: IMarkedItems = {};

        _.each(dirsHash, (item) => {
            const id = item.dirid;

            if (id != null) {
                dirs[id] = item.name;
            }
        });

        const contentData = this.state.storeState.dirContent; //this.props.glob.WorkspacesDirsStore._state.data[this.props.id];
        const resources: IMarkedItems = {};

        _.each(contentData, (item) => {
            const id = item.resid;

            if (id != null) {
                resources[id] = item.name;
            }
        });

        return {
            dirs: dirs,
            items: resources
        };
    }

    getSelectAllState = () => {
        const content = this.getContentKeys();

        return calculateSelectAllState(content, this.state.markedDirs, this.state.markedItems);
    };

    handleOnSelectAllChange = (value: boolean) => {
        if (typeof this.props.onMark === 'function') {
            if (value) {
                const obj = this.getContentKeys();

                this.props.onMark(obj.dirs, { ...obj.items });
                this.state.storeState.selectedResources = { ...obj.items };
            } else {
                this.props.onMark({}, {});
                this.state.storeState.selectedResources = {};
            }
        }
    };

    render() {
        const rootId = this.state.storeState.resourceTreeRootDirId; //this.props.rootId != null ? this.props.rootId : config.WIDGETS_ROOT_DIR_ID;
        const rootName = this.props.name;

        let content: React.JSX.Element;
        let contentDirs: React.JSX.Element;

        if (rootId === -1 || this.state.selectedDirId === -1) {
            content = <ProgressBar />;
        } else {
            content = this.getView();

            contentDirs = (
                <DirsTreeFlat
                    instanceId={rootId.toString()}
                    mode={DirsTreeModes.RESOURCE_SELECT}
                    rootId={rootId}
                    rootName={rootName}
                    displayId={this.state.selectedDirId}
                    canEdit={false}
                    useSearching={this.props.useSearching}
                    showSelectAll={this.props.markMode}
                    markMode={this.props.markMode}
                    marked={this.props.markedDirs}
                    getSelectAllState={this.getSelectAllState}
                    glob={this.props.glob}
                    onMark={this.handleOnDirsMark}
                    onSelect={this.handleOnDirSelect}
                    onSelectAllChange={this.handleOnSelectAllChange}
                />
            );
        }

        return (
            <div className={'dirs-flat dirs-workspaces-flat' + (this.state.storeState.loading ? ' loading' : '')}>
                {contentDirs}
                {content}
            </div>
        );
    }
}
